/**
 * The first-day card (docs/ux/VALUE-CASE-AND-STEELMAN.md: show the payoff at the moment, time to value under 3 min):
 * two quick wins right where setup lands. Label food (one tap to start, a label in three) and Inspection supplies (core
 * shopkit.ts). Safety text stays plain: no jokes here (docs/marketing/AD-CAMPAIGN.md).
 */
import { Card, LinkButton } from "./ui.tsx";

export function FirstDayWins({ home, manager }: { home?: boolean; manager?: boolean }) {
  return (
    <Card edge="go" className="stack-sm first-wins" as="div">
      <p className="kicker">Your first day</p>
      <h2>{home ? "Label your leftovers" : "Two quick wins"}</h2>
      <p>{home ? "Say what it is. The use-by date is on the label." : "Label a food in three taps. Then see what an inspector checks for."}</p>
      <div className="btn-row">
        <LinkButton to="/food/label" big icon="write">{home ? "Label leftovers" : "Label food"}</LinkButton>
        {!home && manager && <LinkButton to="/supplies/kit" variant="secondary" icon="cart">See inspection supplies</LinkButton>}
      </div>
    </Card>
  );
}
